import Sidebar from './NavigationSidebar.container';

export default Sidebar;
